module.exports = __webpack_public_path__ + "static/img/logo.1745385299907.png";